<h2 mat-dialog-title>Welcome to SeedMC</h2>
<div mat-dialog-content>
    <p>
        Welcome!
    </p>
</div>
<div mat-dialog-actions align="end">
    <button mat-flat-button color="primary" (click)="close()">Close</button>
</div>
